import equal from 'react-fast-compare'
import { useParams } from 'react-router-dom'
import { getDataFromState } from 'utils/get'
import { mapResponseToFormError } from 'utils/form'
import { useTypedSelector, usePromiseDispatch } from 'etc/reducers'
import { TUseCreateModal, TUseCreateItemModalParams } from 'types/hooks'
import { TGetDataFromState } from 'types'
import { path } from 'ramda'
import toSnakeCase from '../utils/toSnakeCase'
import useModal from './useModal'

export const onOpenModal = ({ value, params, history, onOpen }) => {
  onOpen()
  if (params.onOpen) {
    params.onOpen(params.key, value, history)
  }
}

export const onCloseModal = ({ onClose, params, history }) => {
  onClose()
  if (params.onClose) {
    params.onClose(params.key, history)
  }
}

const useCreateModal = <T extends any>(params: TUseCreateItemModalParams): TUseCreateModal<T> => {
  const {
    key = 'createModal',
    action,
    stateName,
    onSuccess,
    serializer = toSnakeCase,
    paramKey = 'id'
  } = params

  const { open, onOpen, onClose } = useModal({ key })

  if (!stateName) {
    throw Error('useCreateModal hook requires stateName!')
  }
  const paramsRoute = useParams()
  const dispatch = usePromiseDispatch()
  const state = useTypedSelector<TGetDataFromState<T>>(state => getDataFromState(state, stateName), equal)

  const onSubmit = (values: Record<string, any>) => {
    const serializeValues = serializer(values)
    const id: string = path([paramKey], paramsRoute)
    return dispatch(action(id, serializeValues))
      .then(data => {
        if (onSuccess) onSuccess(data, values)
      })
      .then(() => onClose())
      .catch(mapResponseToFormError)
  }

  return {
    open,
    onOpen,
    onClose,
    onSubmit,
    ...state
  }
}

export default useCreateModal
